import { motion } from "framer-motion";

const JOURNEY = [
  { label: "A single spark", size: 6, glow: 12, color: "#FF8800" },
  { label: "Idea", size: 10, glow: 18, color: "#FF8800" },
  { label: "Concept", size: 14, glow: 26, color: "#00B0FF" },
  { label: "Business", size: 18, glow: 34, color: "#00B0FF" },
  { label: "Customers", size: 23, glow: 44, color: "#00E676" },
  { label: "Revenue", size: 28, glow: 56, color: "#00E676" },
  { label: "Employment", size: 34, glow: 70, color: "#FF8800" },
  { label: "Growth", size: 42, glow: 90, color: "#FF8800" },
];

export function Transform() {
  return (
    <section id="transform" data-testid="transform-section" className="relative py-20 sm:py-28 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,rgba(255,136,0,0.06),transparent_60%)] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-3xl mx-auto"
        >
          <p className="font-mono-tech text-xs tracking-[0.35em] text-[#00B0FF] uppercase mb-4">05 — The Journey</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white" data-testid="transform-headline">
            AN IDEA IS ONLY <span className="text-gradient-saffron">THE BEGINNING.</span>
          </h2>
        </motion.div>

        <div className="mt-16 flex flex-col items-center gap-7" data-testid="transform-journey">
          {JOURNEY.map((j, i) => (
            <motion.div
              key={j.label}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.55, delay: 0.05 }}
              className="flex items-center gap-5"
              data-testid={`transform-step-${j.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div
                className="rounded-full shrink-0 animate-pulse-node"
                style={{
                  width: j.size,
                  height: j.size,
                  background: j.color,
                  boxShadow: `0 0 ${j.glow}px ${j.color}aa, 0 0 ${j.glow * 2}px ${j.color}44`,
                }}
              />
              <span
                className="font-display font-semibold tracking-[0.12em] text-white"
                style={{ fontSize: `${0.85 + i * 0.14}rem` }}
              >
                {j.label.toUpperCase()}
              </span>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-16 text-center text-lg sm:text-xl text-slate-300 max-w-2xl mx-auto leading-relaxed"
          data-testid="transform-statement"
        >
          LaunchLab helps turn ideas into{" "}
          <span className="text-gradient-india font-semibold">economic opportunities.</span>
        </motion.p>
      </div>
    </section>
  );
}
